import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full bg-paper px-5 py-20 sm:py-28" data-id="element-82" data-mp="1lc231ky1rhuv">
      <div className="mx-auto max-w-3xl" data-id="element-83" data-mp="1ge0ggq1ex0en">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-5xl" data-id="element-84" data-mp="1gaus5d0ly2jz">
          Frequently Asked Questions
        </h2>

        <div className="mt-12 space-y-4" data-id="element-85" data-mp="2924nbevpzjix">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className={`overflow-hidden rounded-2xl border-2 border-ink bg-white transition-shadow duration-200 ease-out ${isOpen ? 'shadow-pop' : ''}`} data-id="element-86" data-mp="1z3714ilro233" data-mpi={index}>
                <h3 data-id="element-87" data-mp="sl0h90zumo2d">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-5 py-5 text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-royal/30 sm:px-6" data-id="element-88" data-mp="no0aenv6dha7">
                    <span className="font-display text-base font-bold text-ink" data-id="element-89" data-mp="uey8jy99daml">
                      {faq.q}
                    </span>
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 border-ink transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-sun' : 'bg-white'}`} data-id="element-90" data-mp="kil7gfbdvuht">
                      <PlusIcon className="h-4 w-4 text-ink" aria-hidden="true" data-id="element-91" data-mp="biydufowbszb" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-92" data-mp="1sd7u76w7m6d">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-93" data-mp="1svdfufg3cqy">
                      <div className="space-y-3 px-5 pb-6 text-sm leading-relaxed text-ink-soft sm:px-6 sm:text-base" data-id="element-94" data-mp="1po1j3bsq19g2">
                        {faq.a.map(paragraph => <p key={paragraph} data-id="element-95" data-mp="1fsgjfkb4kl9h">{paragraph}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}